export enum ResourceRoles {
    BUYER = "buyer",
    SUPPLIER = "supplier",
    WORKER = "worker",
}